import React, { useState } from "react";
import "./Tyre.css";
import Breadcrumb from "../../../../components/Breadcrum";
import { Modal, Button } from "react-bootstrap";

const OtrTyres = () => {

    const tyreData = [
        {
            id: 1,
            name: "DFA601",
            outerImg: "/assets/img/otr/outer-images/DFA601.jpg",
            innerImg: "/assets/img/otr/inner-images/DFA601.jpg",
        },
        {
            id: 2,
            name: "DFA602S",
            outerImg: "/assets/img/otr/outer-images/DFA602S.jpg",
            innerImg: "/assets/img/otr/inner-images/DFA602S.jpg",
        },
        {
            id: 3,
            name: "DS706",
            outerImg: "/assets/img/otr/outer-images/DS706.jpg",
            innerImg: "/assets/img/otr/inner-images/DS760.jpg",
        },
        {
            id: 4,
            name: "DSR656",
            outerImg: "/assets/img/otr/outer-images/DSR656.jpg",
            innerImg: "/assets/img/otr/inner-images/DSR656.jpg",
        },
        {
            id: 5,
            name: "DSR668",
            outerImg: "/assets/img/otr/outer-images/DSR668.jpg",
            innerImg: "/assets/img/otr/inner-images/DSR668.jpg",
        },
        {
            id: 6,
            name: "DSRR01",
            outerImg: "/assets/img/otr/outer-images/DSRR01.jpg",
            innerImg: "/assets/img/otr/inner-images/DSRR01.jpg",
        },
        {
            id: 7,
            name: "FIO628",
            outerImg: "/assets/img/otr/outer-images/FIO628.jpg",
            innerImg: "/assets/img/otr/inner-images/FIO628.jpg",
        },
        {
            id: 8,
            name: "TRP77",
            outerImg: "/assets/img/otr/outer-images/TRP77.jpg",
            innerImg: "/assets/img/otr/inner-images/TRP77.jpg",
        },
        {
            id: 9,
            name: "TRP78",
            outerImg: "/assets/img/otr/outer-images/TRP78.jpg",
            innerImg: "/assets/img/otr/inner-images/TRP78.jpg",
        },
        {
            id: 10,
            name: "TRP79",
            outerImg: "/assets/img/otr/outer-images/TRP79.jpg",
            innerImg: "/assets/img/otr/inner-images/TRP79.jpg",
        },
    ];

    const [selectedTyre, setSelectedTyre] = useState(null);

    const openModal = (tyre) => setSelectedTyre(tyre);
    const closeModal = () => setSelectedTyre(null);

    return (
        <>
            <Breadcrumb
                title="OTR CATALOGUE"
                backgroundImage={"./assets/img/contact-banner.png"}
                height="40vh"
            />

            <section className="lyt-section tyers-section OTR-CATALOGUE">
                <div className="container">
                    <h2 className="heading01 text-center">
                        <span>OTR</span> CATALOGUE
                    </h2>

                    <div className="tyre-grid">
                        {tyreData.map((tyre) => (
                            <div
                                className="tyre-box"
                                key={tyre.id}
                                onClick={() => openModal(tyre)}
                            >
                                <div className="imageWrapper">
                                    <img src={tyre.outerImg} alt={tyre.name} className="image" />
                                </div>

                                <h4 className="text-center">{tyre.name}</h4>
                            </div>
                        ))}
                    </div>

                    <Modal show={!!selectedTyre} onHide={closeModal} centered className="custom">
                        <Modal.Header closeButton>
                            <Modal.Title>{selectedTyre?.name}</Modal.Title>
                        </Modal.Header>

                        <Modal.Body className="text-center">
                            <img
                                src={selectedTyre?.innerImg}
                                alt={selectedTyre?.name}
                                style={{ width: "100%" }}
                            />
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={closeModal}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </section>
        </>
    );
};

export default OtrTyres;